var exports = {
  "lJ": "AttachmentMosaic.module__mosaicContainerWrapper___cG9HYT",
  "Yt": "AttachmentMosaic.module__mosaicContainer___cG9HYT",
};

module.exports = exports;
